import React from "react";

const Success = () => (
    <section data-bs-version="5.1" className="team2 cid-success-page" id="payment-success">
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card shadow-lg p-4 text-center">
                        <h3 className="mbr-section-title mbr-fonts-style text-danger display-2">
                            Оплата прошла успешно!
                        </h3>
                        <p className="mbr-text mbr-fonts-style display-7 mt-3">
                            Спасибо за покупку. Подтверждение отправлено на вашу почту.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

Success.link = "/success";

export default Success;
